import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  Badge,
  Button,
  Card,
  Col,
  Popconfirm,
  Row,
  Table,
  Tooltip,
  Typography,
  message
} from "antd";
import { forEach, get, isNumber, size } from "lodash";
import React, { useState } from "react";
import service from "../../../../../services";
import barrierService from "../../../../../services/BarrierService";
import { DEFAULT_VALUE } from "../../../app/_redux/constants";
import { PAGINATION } from "../../_redux/constant";
import AddEditCamera from "./modals/addEditCamera";
import dayjs from "dayjs";

const { Text } = Typography;
function Cameras({
  total_elements,
  loading,
  dataSource,
  params,
  onChangeParam,
  onClickCreate,
  allStations
}) {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const CARD_BODY_STYLE = {
    padding: "0px 10px 10px 10px"
  };
  const CARD_HEAD_STYLE = {
    padding: "0px 9px 0px 9px",
    borderBottom: "none"
  };
  const SNoStyle = {
    color: "#14a05b",
    fontWeight: "bold",
    display: "inline-block",
    textAlign: "center"
  };

  const Password = ({ password }) => {
    const [visible, setVisible] = useState({
      value: false
    });

    const _handleShowPass = () => {
      setVisible(prev => ({
        ...prev,
        value: !visible.value
      }));
    };

    return !password ? (
      ""
    ) : (
      <Tooltip placement="topLeft" title={"Hiển thị mật khẩu"}>
        <b style={{ cursor: "default" }} onClick={_handleShowPass}>
          {visible.value ? password : "**********"}
        </b>
      </Tooltip>
    );
  };

  const CellAction = ({ record }) => {
    const [modal, setModal] = useState({
      visible: false,
      isEdit: true,
      id: null,
      data: null,
      stations: allStations,
      gates: [],
      dvrs: []
    });

    const _handleShowModal = async () => {
      let gates = [];
      const dvrs = [];
      if (record && record.station_id) {
        const response = await barrierService.getGateByStationId({
          station_id: record.station_id
        });
        if (response && response.data && response.data.success) {
          gates = get(response.data, "data");
        }

        const dvrResponse = await service.IOT.getListDvrInfo({
          station_search: { station_id: [record.station_id] },
          limit: 1000,
          offset: 1
        });
        if (dvrResponse.success && size(dvrResponse.data) > 0) {
          forEach(dvrResponse.data, dvr => {
            dvrs.push({
              dvr_id: dvr._id,
              dvr_name: get(dvr, "dvr_name", "")
            });
          });
        }
      }
      setModal(prev => ({
        ...prev,
        visible: !prev.visible,
        isEdit: !prev.visible ? true : false,
        id: record.id,
        data: record,
        stations: allStations,
        gates,
        dvrs
      }));
    };

    const _handleDeleteCamera = async () => {
      const response = await barrierService.deleteCamera(record.id);
      if (response && response.data && response.data.success) {
        message.success(
          get(response, "data.message", "Xóa camera barrier thành công.")
        );
        onChangeParam({
          page: params.page,
          size: params.size
        });
      } else {
        message.error(get(response, "data.message", "Có lỗi xảy ra."), 5);
      }
    };
    return (
      <>
        <EditOutlined
          onClick={_handleShowModal}
          className="text-primary mr-3"
        />

        <Popconfirm
          cancelText="Quay lại"
          okText="Xác nhận"
          placement="topRight"
          title="Xác nhận xóa camera barrier?"
          onConfirm={_handleDeleteCamera}
        >
          <DeleteOutlined className="text-danger" />
        </Popconfirm>
        <AddEditCamera modal={modal} onShowModal={_handleShowModal} />
      </>
    );
  };

  const columns = [
    {
      dataIndex: "stt",
      title: "STT",
      align: "center"
    },
    {
      dataIndex: "station_name",
      title: "Kho",
      key: "station_name",
      align: "left",
      render: (station_name, record) => {
        return (
          <Text>
            <span style={SNoStyle}>{get(record, "station_id", "-")}</span>
            {station_name ? " | " + station_name : " | " + DEFAULT_VALUE}
          </Text>
        );
      }
    },
    {
      dataIndex: "gate_name",
      key: "gate_name",
      title: "Tên cổng",
      align: "left",
      render: value => value || DEFAULT_VALUE
    },
    {
      title: "Camera",
      children: [
        {
          dataIndex: "name",
          key: "name",
          title: "Tên camera",
          align: "left",
          render: value => value || DEFAULT_VALUE
        },
        {
          title: "SN camera",
          dataIndex: "sn",
          key: "sn",
          align: "center",
          render: value => value || DEFAULT_VALUE
        },
        {
          dataIndex: "ip",
          key: "ip",
          title: "IP camera",
          align: "center",
          render: ip => ip || DEFAULT_VALUE
        },
        {
          dataIndex: "port",
          key: "port",
          title: "Port",
          align: "center",
          render: value => value || DEFAULT_VALUE
        },

        {
          title: "Trạng thái",
          dataIndex: "status",
          align: "center",
          render: value => {
            if (isNumber(value) && value >= 0) {
              return (
                <Badge
                  color={value === 0 ? "red" : "green"}
                  text={value === 0 ? "Offline" : "Online"}
                />
              );
            }
            return;
          }
        },
        {
          title: "Lần cuối online",
          dataIndex: "latest_online",
          align: "center",
          render: value => {
            return value ? dayjs(value).format("DD/MM/YYYY HH:mm:ss") : "";
          }
        },
        {
          dataIndex: "username",
          key: "username",
          title: "Tên đăng nhập",
          align: "center",
          render: value => value || DEFAULT_VALUE
        },
        {
          dataIndex: "password",
          title: "Mật khẩu",
          align: "center",
          render: password => <Password password={password} />
        }
      ]
    },
    {
      title: "PC",
      children: [
        {
          dataIndex: "gbarrier_ip",
          key: "gbarrier_ip",
          title: "IP server",
          align: "center",
          render: ip => ip || DEFAULT_VALUE
        },
        {
          dataIndex: "gbarrier_port",
          key: "gbarrier_port",
          title: "Port server",
          align: "center",
          render: value => value || DEFAULT_VALUE
        },
        {
          dataIndex: "pc_mac",
          key: "pc_mac",
          title: "MAC server",
          align: "center",
          render: value => value || DEFAULT_VALUE
        },
        {
          title: "Trạng thái",
          dataIndex: "pc_status",
          align: "center",
          render: value => {
            if (isNumber(value) && value >= 0) {
              return (
                <Badge
                  color={value === 0 ? "red" : "green"}
                  text={value === 0 ? "Offline" : "Online"}
                />
              );
            }
            return;
          }
        },
        {
          title: "Lần cuối online",
          dataIndex: "pc_updated_date",
          align: "center",
          render: value => {
            return value ? dayjs(value).format("DD/MM/YYYY HH:mm:ss") : "";
          }
        }
      ]
    },

    {
      dataIndex: "action",
      title: "Hành động",
      width: 100,
      render: (_, record) => <CellAction record={record} />,
      align: "center"
    }
  ];

  const renderCardExtra = () => {
    return (
      <div className="d-flex aligns-items-center">
        <Button
          onClick={() => {
            onChangeParam({
              page: params.page,
              size: params.size
            });
          }}
          type="dashed"
          className="mr-3"
        >
          Làm mới
        </Button>

        <Button onClick={onClickCreate} type="primary">
          Thêm mới
        </Button>
      </div>
    );
  };
  return (
    <Card
      className="log__container"
      size="small"
      style={CARD_STYLE}
      bodyStyle={CARD_BODY_STYLE}
      headStyle={CARD_HEAD_STYLE}
      title={
        <Row align="middle" gutter={[8]} justify="start">
          <Col>
            <Text>
              Tổng số camera:{" "}
              <Text className="text-dark">{total_elements}</Text>
            </Text>
          </Col>
        </Row>
      }
      extra={renderCardExtra()}
    >
      <Table
        loading={loading}
        rowKey="id"
        size="large"
        bordered
        columns={columns}
        dataSource={dataSource}
        pagination={{
          pageSize: params.size,
          current: params.page,
          defaultPageSize: PAGINATION.camera.page,
          total: total_elements,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            onChangeParam({
              page: page,
              size: pageSize
            });
          }
        }}
        scroll={{ x: 1366 }}
      />
    </Card>
  );
}

export default React.memo(Cameras);
